import * as React from 'react'
import { connect } from 'react-redux'

import * as Yup from 'yup'
import DatePicker from 'react-datepicker'
import { Form, Formik, FormikProps } from 'formik'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Input, Label, Modal, Button, FormGroup, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'

import { ApplicationUpdateRequest } from 'src//lib/api/applications'
import { JobApplicant } from 'src/lib/interfaces/JobApplicant.interface'

import * as applicationsActions from '../../../store/applications/actions'

interface ApplicationEditionModalProps {
  open?: boolean
	onClose: () => void
	application: JobApplicant
	updateApplication: (applicationId: string, application: ApplicationUpdateRequest, next?: (err?: any, application?: JobApplicant) => void) => void
}

class ApplicationEditionModal extends React.Component<ApplicationEditionModalProps> {
  state = {
    isLoading: false
	}
	
	get initialValues(): ApplicationUpdateRequest|undefined {
		const { application } = this.props

		return {
			city: application.city,
			state: application.state,
			street: application.street,
			driverLicenseNumber: application.driverLicenseNumber,
			driverLicenseExpirationDate: application.driverLicenseExpirationDate
		} as ApplicationUpdateRequest
	}

  get validationSchema() {
    return Yup.object().shape({
			city: Yup.string(),
			state: Yup.string(),
			street: Yup.string(),
			driverLicenseNumber: Yup.string(),
			driverLicenseExpirationDate: Yup.string()
    })
  }

  handleSubmit(values) {
		console.log('Opa')
    const { application, updateApplication } = this.props

    this.setState({ isLoading: true }, () => {
      updateApplication(application.id, values, (err?: any, updatedApplication?: JobApplicant) => {
				console.log('updatedApplication', updatedApplication)
        if (!err) {
          this.setState({ isLoading: false }, this.props.onClose)
        }
      })
    })
  }

  render() {
    const { isLoading } = this.state
    const { open, onClose } = this.props

    return (
      <Modal size="lg" isOpen={open} toggle={onClose}>
        <Formik
          initialValues={this.initialValues}
          onSubmit={values => this.handleSubmit(values)}
          render={(props: FormikProps<ApplicationUpdateRequest>) => {
						console.log(props)
            return (
							<Form>
								<ModalHeader toggle={onClose}>Edit Applicant</ModalHeader>
								<ModalBody>
										<div className="row no-gutters">
											<FormGroup className="col-6 pr-2">
												<Label className="font-weight-bold text-secondary">Driver's License Number</Label>
												<Input
													name="driverLicenseNumber"
													onChange={props.handleChange}
													value={props.values.driverLicenseNumber || ''}
												/>
											</FormGroup>

											<FormGroup className="col-6 pl-2">
												<Label className="font-weight-bold text-secondary">Driver's License Expiration Date</Label>
												<Input
													type="date"
													value={props.values.driverLicenseExpirationDate || ''}
													onChange={e => {
														console.log(props.values)
														console.log('props.isValid', props.isValid)
														console.log(props)
														props.setFieldValue('driverLicenseExpirationDate', e.target.value)
													}}
												/>
											</FormGroup>
											
											<FormGroup className="col-4 pr-1">
												<Label className="font-weight-bold text-secondary">City</Label>
												<Input
													name="city"
													onChange={props.handleChange}
													value={props.values.city || ''}
												/>
											</FormGroup>

											<FormGroup className="col-3 px-1">
												<Label className="font-weight-bold text-secondary">State</Label>
												<Input
													name="state"
													onChange={props.handleChange}
													value={props.values.state || ''}
												/>
											</FormGroup>

											<FormGroup className="col-5 pl-1">
												<Label className="font-weight-bold text-secondary">Street Address</Label>
												<Input
													name="street"
													onChange={props.handleChange}
													value={props.values.street || ''}
												/>
											</FormGroup>
										</div>
								</ModalBody>
								<ModalFooter>
									<Button color="light" onClick={onClose} disabled={isLoading}>Cancel</Button>
									<Button type="submit" color="primary" disabled={isLoading || !props.dirty}>
										{isLoading &&
											<FontAwesomeIcon spin className="mr-2" icon={['fas', 'spinner']} />
										}
										Save
									</Button>
								</ModalFooter>
							</Form>
						)
					}}
        />
      </Modal>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
	updateApplication: (applicationId: string, application: ApplicationUpdateRequest, next?: (err?: any, application?: JobApplicant) => void) =>
		dispatch(applicationsActions.updateApplication(applicationId, application, next))
})

export default connect(null, mapDispatchToProps)(ApplicationEditionModal)



// WEBPACK FOOTER //
// ./src/routes/applications/components/ApplicationEdition.modal.tsx